import React, { useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import CreateShareableLinkContext from 'router/subrouters/DataRoom/providers/CreateShareableLink/CreateShareableLink.context';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import DataRoomDocumentsContext from '../providers/DataRoomDocuments/DataRoomDocuments.context';

import './CreateShareableLinkButton.styles.scss';

type CreateShareableLinkButtonProps = {
  className?: string;
};

const CreateShareableLinkButton: React.FC<CreateShareableLinkButtonProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('create-shareable-link-button', className);

  const { openCreateShareableLink } = useContext(CreateShareableLinkContext);

  const { canUserCreateShareableLinks } = useContext(DataRoomContext);
  const { isDataRoomEmpty } = useContext(DataRoomDocumentsContext);

  const { t } = useTranslation();

  if (!canUserCreateShareableLinks || isDataRoomEmpty) return null;

  return (
    <Button className={classes} onClick={() => openCreateShareableLink()}>
      {t('createSecureShare')}
    </Button>
  );
};

export default CreateShareableLinkButton;
